import RequestBuilder from 'Resources/RequestBuilder';
import T from 'Components/Helpers/translate';
import { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import NotificationService from 'App/babel/NotificationService';
import openModal from 'App/services/Modal';
import type { Options as DeactivationOptions } from 'App/babel/components/Account/AccountDeactivationModal';
import MultiActions from 'Resources/MultiActions';

export default async function inactivateCompanies(
	requestBuilder: RequestBuilder,
	entity: string,
	multiSelect: MultiSelect,
	customerId: number
) {
	const deactivationOptions = await new Promise<DeactivationOptions | null>(resolve => {
		openModal('AccountDeactivationModal', {
			company: {
				name:
					multiSelect.selected > 1
						? `${multiSelect.selected} ${T('default.clients').toLowerCase()}`
						: `1 ${T('default.client').toLowerCase()}`,
				active: 1,
				journeyStep: '', // FIX IN NEXT ISSUE TO MULTIUPDATE JOURNEY STEP
				id: 0 // Not needed for multi-inactivate
			},
			onClose: (options?: DeactivationOptions) => {
				if (options) {
					resolve(options);
				} else {
					resolve(null);
				}
			},
			multi: true
		});
	});

	if (!deactivationOptions) {
		return;
	}
	const properties = [
		{ name: 'Active', value: '0' },
		{ name: 'DeactivationReason', value: deactivationOptions.reason }
	];

	//FIX
	if (deactivationOptions.disqualify) {
		properties.push({ name: 'JourneyStep', value: 'disqualified' });
	}

	// FIX IN NEXT ISSUE TO MULTIUPDATE JOURNEY STEP AND INACTIVATE CONTACTS ON COMPANIES IF SELECTED
	const extraParams: Record<string, any> = {};
	if (deactivationOptions.moveOrdersToStageId) {
		extraParams.moveOrdersToStageId = deactivationOptions.moveOrdersToStageId;
	}
	if (deactivationOptions.inactivateContacts) {
		extraParams.inactivateContacts = true;
	}

	try {
		const response = await MultiActions.customer(customerId).updateAccount(
			entity,
			multiSelect.selected,
			properties,
			requestBuilder.build(),
			extraParams
		);

		// If we selected 10 or fewer, update them now
		if (multiSelect.selected <= 10) {
			// Wait for index then show notification
			setTimeout(() => {
				NotificationService.add({
					style: NotificationService.style.SUCCESS,
					icon: 'check',
					title: 'default.saved',
					body: T('multi.inactivateCompanies.done', { count: multiSelect.selected })
				});
			}, 2000);
		} else {
			// More than 10 - a job will be created
			NotificationService.add({
				style: NotificationService.style.SUCCESS,
				icon: 'check',
				title: 'default.saved',
				body: T('updateQued.inactivateCompanies')
			});
		}

		return response;
	} catch (e) {
		NotificationService.add({
			style: NotificationService.style.ERROR,
			icon: 'times',
			title: 'default.error',
			body: e
		});
		throw e;
	}
}
